module.exports = "/_next/static/images/af72a045a2f66461373665b8ecfa98ed-valor-logo.png.webp";